import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemContent,
  ColorPaletteProp,
  ListDivider,
  Sheet,
  Table,
  iconButtonClasses,
  Button,
  IconButton,
  Card,
  Input,
  Dropdown,
  MenuButton,
  Menu,
  MenuItem,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, PageTitle, StatusBadge } from "../../../components";
import { formatDate } from "../../../utils";

import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import { fetchAllApiReset, fetchAllApiRequest } from "../../../store/actions";

import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import {
  CalendarMonthOutlined,
  FilterAltOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined,
  WarningRounded,
} from "@mui/icons-material";
import { STATUS } from "../../../constant";
import {
  NAVIGATE_TO_APIACCESSVIEWPAGE,
  NAVIGATE_TO_VIEWLOGGEDINAPIDETAILSPAGE,
} from "../../../route/types";

const MobileViewTable = ({ data, props }) => {
  return (
    <Box sx={{ display: { xs: "block", md: "none" } }}>
      {data.map((listItem, index) => (
        <List
          key={index}
          size="sm"
          sx={{
            "--ListItem-paddingX": 0,
          }}
        >
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <ListItemContent
              sx={{ display: "flex", gap: 2, alignItems: "start" }}
            >
              <div>
                <Typography level="body-xs" gutterBottom>
                  <b>Secret Key:</b> {listItem.secret_key}
                </Typography>
                <Typography level="body-xs" gutterBottom>
                  <b>Owner:</b> {listItem.owner_name}
                </Typography>
                <Typography level="body-xs" gutterBottom>
                  <b>Email: </b>
                  {listItem.email}
                </Typography>

                <Dropdown>
                  <MenuButton variant="plain" size="sm">
                    More ...
                  </MenuButton>
                  <Menu placement="bottom-end" sx={{ p: 1 }}>
                    <Typography level="body-sm" gutterBottom>
                      <b>Created at:</b> {formatDate(listItem.created_at)}
                    </Typography>
                    <Typography level="body-sm" gutterBottom>
                      <b>Approved at: </b>
                      {formatDate(listItem.approved_at)}
                    </Typography>
                  </Menu>
                </Dropdown>
              </div>
            </ListItemContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
                rowGap: 1,
              }}
            >
              <StatusBadge
                color={
                  {
                    1: "success",
                    2: "warning",
                    3: "neutral",
                    4: "danger",
                    5: "neutral",
                  }[listItem.status] as ColorPaletteProp
                }
              >
                {
                  {
                    1: "Active",
                    2: "Inactive",
                    3: "pending for approval",
                    4: "Rejected",
                    5: "Pending for additional",
                  }[listItem.status]
                }
              </StatusBadge>
            </Box>
          </ListItem>
          <ListDivider />
        </List>
      ))}
    </Box>
  );
};

const DesktopViewTable = ({ data, props }) => {
  const rows = Array.isArray(data) ? data : [data];

  return (
    <React.Fragment>
      <Sheet
        className="OrderTableContainer"
        variant="soft"
        sx={{
          display: { xs: "none", md: "flex", lg: "flex" },
          borderRadius: "sm",
          flexShrink: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        <Table
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            "--TableCell-headBackground":
              "var(--joy-palette-background-level2)",
            "--Table-headerUnderlineThickness": "1px",
            "--TableRow-hoverBackground":
              "var(--joy-palette-background-level1)",
            "--TableCell-paddingY": "4px",
            "--TableCell-paddingX": "8px",
            tableLayout: "fixed",
            "& tr > *:last-child": {
              position: "sticky",
              right: 0,
            },
          }}
        >
          <thead>
            <tr style={{ textAlign: "center" }}>
              <th style={{ width: "12%", padding: "10px 6px" }}>Owner Name</th>
              <th style={{ width: "14%", padding: "10px 6px" }}>Client ID</th>
              <th style={{ width: "18%", padding: "10px 6px" }}>Secret Key</th>
              <th style={{ width: "10%", padding: "10px 6px" }}>FSP Code</th>
              <th style={{ width: "8%", padding: "10px 6px" }}>Status</th>
              <th
                aria-label="last"
                style={{ width: "14%", padding: "10px 6px" }}
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>
                  <Typography level="body-sm" sx={{ wordBreak: "break-word" }}>
                    {row.owner_name}
                  </Typography>
                </td>
                <td>
                  <Typography level="body-sm" sx={{ wordBreak: "break-word" }}>
                    {row.client_id}
                  </Typography>
                </td>
                <td>
                  <Typography level="body-sm" sx={{ wordBreak: "break-word" }}>
                    {row.secret_key}
                  </Typography>
                </td>
                <td>
                  <Typography level="body-sm">{row.fsp_code}</Typography>
                </td>
                <td>
                  <StatusBadge
                    color={
                      {
                        1: "success",
                        2: "warning",
                        3: "neutral",
                        4: "danger",
                        5: "neutral",
                      }[row.status] as ColorPaletteProp
                    }
                  >
                    {
                      {
                        1: "Active",
                        2: "Inactive",
                        3: "pending for approval",
                        4: "Rejected",
                        5: "Pending for additional",
                      }[row.status]
                    }
                  </StatusBadge>
                </td>
                <td>
                  <Button
                    variant="soft"
                    color="primary"
                    onClick={() => props.view(row)}
                  >
                    <RemoveRedEyeOutlined />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Sheet>
    </React.Fragment>
  );
};

const ApiAccessPage = ({
  loginResult,

  apiListStatus,
  apiListResult,
  apiListErrorMessage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery("(min-width:600px)");

  if (loginResult?.role !== 1) {
    navigate(NAVIGATE_TO_VIEWLOGGEDINAPIDETAILSPAGE);
  }

  const [apiData, setApiData] = useState([]);

  useEffect(() => {
    if (apiListStatus === STATUS.SUCCESS) {
      setApiData(apiListResult);
      // dispatch(fetchApiReset())
    } else if (apiListStatus === STATUS.ERROR) {
      setApiData([]);
      toast.error(apiListErrorMessage);
      dispatch(fetchAllApiReset());
    }
  }, [apiListStatus, apiListErrorMessage, dispatch, apiListResult]);

  /* -------- FUNCTION TO SEARCH ------ */
  const [search, setSearch] = useState("");
  const [filterBy, setFilterBy] = useState("name");

  // filtre by  name
  const filteredData = apiData.filter((item) => {
    if (filterBy === "name") {
      return item.owner_name.toLowerCase().includes(search.toLowerCase());
    } else if (filterBy === "date") {
      return item.created_at.includes(search);
    } else if (filterBy === "email") {
      return item.email.toLowerCase().includes(search.toLowerCase());
    } else {
      return item.owner_name.toLowerCase().includes(search.toLowerCase());
    }
  });

  /* ------ pagination functions ------- */
  const [currentPage, setCurrentPage] = useState(0);
  const ITEMS_PER_PAGE = 20;
  const pageLength = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(0, prevPage - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, pageLength - 1));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = filteredData.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE,
  );
  /* ---- end of pagination functions ------- */

  /* -------- actions ----------- */

  const goToViewPage = (details) => {
    navigate(NAVIGATE_TO_APIACCESSVIEWPAGE, {
      state: { id: details.id },
    });
  };

  const checkLoading = () => {
    if (apiListStatus === STATUS.LOADING) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box>
      <PageTitle title={"API Access"} />

      <LoadingView loading={checkLoading()} />

      {/* search */}
      {loginResult.partner_type === 1 && apiData.length > 0 && (
        <Sheet
          className="SearchAndFilters"
          sx={{
            display: "flex",
            my: 1,
            gap: 1,
            flexDirection: { xs: "column", sm: "row" },
            // width: { xs: 'auto', md: '30%' },
            justifyContent: "space-between",
          }}
        >
          <Typography level="title-md">API List</Typography>

          <Input
            size="sm"
            placeholder={`Search by ${filterBy}`}
            type={
              { date: "date", name: "text", email: "email", mobile: "number" }[
                filterBy
              ]
            }
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            startDecorator={
              filterBy === "date" ? <CalendarMonthOutlined /> : <SearchIcon />
            }
            endDecorator={
              <Dropdown>
                <MenuButton variant="plain">
                  {/* <Typography level="body-sm">Filter</Typography> */}
                  <FilterAltOutlined />
                </MenuButton>
                <Menu sx={{ minWidth: "120px", fontSize: "14px" }}>
                  <MenuItem
                    onClick={() => setFilterBy("name")}
                    selected={filterBy == "name"}
                  >
                    Owner Name
                  </MenuItem>
                  <MenuItem
                    onClick={() => setFilterBy("email")}
                    selected={filterBy == "email"}
                  >
                    Email
                  </MenuItem>
                  <MenuItem
                    onClick={() => setFilterBy("date")}
                    selected={filterBy == "date"}
                  >
                    Created at
                  </MenuItem>
                </Menu>
              </Dropdown>
            }
            sx={{
              width: { xs: "auto", md: "30%" },
              textTransform: "capitalize",
            }}
          />
        </Sheet>
      )}

      {loginResult.partner_type === 1 &&
        (apiData.length > 0 ? (
          <>
            {/* ------ render different view depend on plafform -------- */}
            <MobileViewTable
              data={paginatedData}
              props={{
                view: goToViewPage,
                role: loginResult.role,
              }}
            />
            <DesktopViewTable
              data={paginatedData}
              props={{
                view: goToViewPage,
                role: loginResult.role,
              }}
            />

            {/* Pagination */}
            {apiData.length > ITEMS_PER_PAGE && (
              <Box
                className="Pagination-laptopUp"
                sx={{
                  pt: 2,
                  gap: 1,
                  [`& .${iconButtonClasses.root}`]: { borderRadius: "50%" },
                  display: "flex",
                }}
              >
                <Button
                  size="sm"
                  variant="outlined"
                  color="neutral"
                  startDecorator={<KeyboardArrowLeftIcon />}
                  onClick={handlePreviousPage}
                  disabled={currentPage === 0}
                >
                  {isDesktop ? "Previous" : ""}
                </Button>

                <Box sx={{ flex: 1 }} />
                {/* for desktop to display page number */}
                {Array.from({ length: pageLength }).map((_, page) => (
                  <IconButton
                    key={page}
                    size="sm"
                    variant={"outlined"}
                    color="neutral"
                    onClick={() => handlePageChange(page)}
                    disabled={currentPage === page}
                    sx={{ display: { xs: "none", md: "flex" } }}
                  >
                    {page + 1}
                  </IconButton>
                ))}

                {/* for mobile to display page number */}
                <Typography
                  level="body-sm"
                  mx="auto"
                  textAlign={"center"}
                  sx={{ display: { xs: "flex", md: "none" } }}
                >
                  Page {currentPage + 1} of {pageLength}
                </Typography>
                <Box sx={{ flex: 1 }} />

                <Button
                  size="sm"
                  variant="outlined"
                  color="neutral"
                  endDecorator={<KeyboardArrowRightIcon />}
                  onClick={handleNextPage}
                  disabled={currentPage === pageLength - 1}
                >
                  {isDesktop ? "Next" : ""}
                </Button>
              </Box>
            )}
          </>
        ) : (
          <Card
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              top: "20%",
            }}
          >
            <WarningRounded
              sx={{ fontSize: "50px", color: "background.appcolor" }}
            />
            <Typography level="title-md">Resource not Found</Typography>
            <Typography level="body-sm" textAlign={"center"}>
              This can be either no api list available or network issue.
            </Typography>
            <Button
              onClick={() =>
                dispatch(fetchAllApiRequest(loginResult.token), {})
              }
              startDecorator={<RefreshOutlined />}
            >
              REFRESH
            </Button>
          </Card>
        ))}
    </Box>
  );
};

const mapStateToProps = ({ api, auth }) => {
  const { otpResult: loginResult } = auth;
  const { apiListResult, apiListStatus, apiListErrorMessage } = api;

  return {
    loginResult,

    apiListStatus,
    apiListResult,
    apiListErrorMessage,
  };
};

export default connect(mapStateToProps, {})(ApiAccessPage);
